import { createSelector } from '@ngrx/store';
import { InvitationState } from './invitation.reducer';

export interface InvitationStoreState {
  invitation: InvitationState;
}

export const selectInvitationState = (state: InvitationStoreState) => state;

export const selectInvitationTokenValidity = createSelector(
  selectInvitationState,
  ({ invitation }) => {
    return invitation.isTokenValid;
  }
);

export const selectInvitationLoading = createSelector(
  selectInvitationState,
  ({ invitation }) => invitation.loading
);

export const selectRequestInProgress = createSelector(
  selectInvitationState,
  ({ invitation }) => invitation.requestInProgress
);
